import {api} from './Api';
import {Folder} from '../models/Folder';

export const getFolder = (uid: string) => {
  return api.get(`folder/${uid}`).then((res: any) => res.data);
};

export const getFolders = () => {
  return api.get('folder/').then((res: any) => res.data);
};

export const createFolder = (data: Partial<Folder>) => {
  return api.post('folder/', data).then((res: any) => res.data);
};

export const updateFolder = (uid: string, data: Partial<Folder>) => {
  return api.put(`folder/${uid}`, data).then((res: any) => res.data);
};

export const deleteFolder = (uid: string) => {
  return api.delete(`folder/${uid}`).then((res: any) => res.data);
};
